import React from "react";

export function SQLGfg() {
    const playlists = [
        { rank: 1, title: "SQL College", url: "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege" },
        { rank: 2, title: "SuperSimpleDev (Highly Recommended)", url: "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev" },
        { rank: 3, title: "PW Skills Tech", url: "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech" },
        { rank: 4, title: "SuperSimpleDev", url: "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org" },
        { rank: 5, title: "Bro Code", url: "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode" },
        { rank: 6, title: "FreeCodeCamp", url: "https://www.youtube.com/watch?v=1Rs2ND1ryYc&ab_channel=freeCodeCamp.org" },
        { rank: 7, title: "Thapa Technical (Recommended)", url: "https://www.youtube.com/watch?v=MSICFljRcb4&t=23300s&ab_channel=ThapaTechnical" },
        { rank: 8, title: "Anuj Bhaiya (TailWind CSS)", url: "https://www.youtube.com/watch?v=mGN9-FPsX9o&t=1043s&ab_channel=AnujBhaiya" },
        { rank: 9, title: "Apna College (Recommended)", url: "https://www.youtube.com/watch?v=nGhKIC_7Mkk&ab_channel=ApnaCollege" },
        { rank: 10, title: "Ws Cube Tech (TailWind CSS)", url: "https://www.youtube.com/watch?v=Sae1MD5E5p8&ab_channel=WsCubeTech" }
    ];

    return (
        <>
            <h1 className="html_yt_heading">
                These are the <strong style={{ textDecoration: "underline", color: "blue" }}>Top 10</strong> YouTube Playlists That You Can Refer
            </h1>
            <h4 className="des_yt_html">
                1. Dive Into The Main Concepts <br />
                2. Animation Explanations with real-world Examples <br />
                3. Important with Note Clarification.
            </h4>

            {playlists.map((playlist) => (
                <div className="container_html_yt_links" key={playlist.rank}>
                    <p className="vid">
                        {playlist.rank}. {playlist.title}
                        <button
                            style={{
                                marginLeft: "200px",
                                padding: "7px",
                                background: "black",
                                color: "white",
                                borderRadius: "8px"
                            }}
                            onClick={() => window.open(playlist.url, "_blank")}
                        >
                            Click Me
                        </button>
                    </p>
                </div>
            ))}
        </>
    );
}

export default SQLGfg;
